export default __webpack_public_path__ + "static/media/PET-KINGDOM.bd3395fb.png";